module.exports = __webpack_public_path__ + "static/media/rm-icon.2aae11ba.png";